import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'CleverDeals';

  constructor(private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    // Listen to every completed route change
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const params = this.router.parseUrl(this.router.url).queryParams;


        this.authService.isAuthenticated$.subscribe(isAuth => {
          if (isAuth) {
            console.log('✅ User is logged in');
          } else {
            // ✅ Handle signup overlay trigger if ?a=signup is in the URL
            if (params['a'] === 'signup') {
              this.authService.showAuthOverlay(true, true);
            }
            else {
              this.authService.showAuthOverlay(true);
            }
          }
        });

       

        // ✅ Capture Facebook Click ID (fbclid) once and store as fbc
        const fbclid = params['fbclid'];
        if (fbclid) {
          // fbc format required by Facebook:
          // fb.1.<timestamp>.<fbclid>
          const fbc = `fb.1.${Date.now()}.${fbclid}`;

          // Store in localStorage so it's available for all future
          // Conversion API calls (AddToCart, Purchase, etc.)
          localStorage.setItem('fbc', fbc);
        }

        // ❌ Do NOT remove fbc when fbclid is missing
        // We need it to persist across the session for events
      });
  }
}
